"use client";

import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import InstagramIcon from "@mui/icons-material/Instagram";
import PinterestIcon from "@mui/icons-material/Pinterest";
import MailIcon from "@mui/icons-material/Mail";
import Image from "next/image";
import Link from "next/link";

export function LandingHeaderbar({
  sticky = false,
  showLoginButton = false,
  loginHref = "/login",
}: {
  sticky?: boolean;
  showLoginButton?: boolean;
  loginHref?: string;
}) {
  return (
    <header
      className={`landing-headerbar${sticky ? " landing-headerbar-sticky" : ""}`}
    >
      <div className="ma-header-top">
        <Link
          href="https://www.modernartifact.com"
          className="ma-header-logo"
          aria-label="Modern Artifact home"
        >
          <Image
            src="/logo.png"
            alt="Modern Artifact"
            width={400}
            height={100}
            priority
          />
        </Link>

        {showLoginButton && (
          <Link href={loginHref} className="ma-header-login-button">
            Login
          </Link>
        )}
      </div>

      <div className="ma-header-bottom">
        <nav className="ma-header-nav" aria-label="Main navigation">
          <Link href="https://www.modernartifact.com">HOME</Link>
          <Link href="https://www.modernartifact.com/collections/art">ART</Link>
          <Link href="/public/appraisal">SELL</Link>
          <Link href="https://www.modernartifact.com/pages/art-advisory">
            ART ADVISORY
          </Link>
          <Link href="https://www.modernartifact.com/pages/about-ma">
            ABOUT US
          </Link>
        </nav>

        <div className="ma-header-social" aria-label="Social links">
          <a
            href="https://www.facebook.com/modernartifact1/"
            aria-label="Facebook"
          >
            <FacebookOutlinedIcon fontSize="small" />
          </a>
          <a
            href="https://www.instagram.com/modern_artifact/"
            aria-label="Instagram"
          >
            <InstagramIcon fontSize="small" />
          </a>
          <a
            href="https://www.pinterest.com/modern_artifact/"
            aria-label="Pinterest"
          >
            <PinterestIcon fontSize="small" />
          </a>
          <a href="mailto:info@modernartifact.com" aria-label="Email">
            <MailIcon fontSize="small" />
          </a>
        </div>
      </div>
    </header>
  );
}
